export default __webpack_public_path__ + "static/media/X-icon.a5852c4e.svg";